<template>
  <section class="container">
    <header class="dialog-header">
      <h1>Mijn opdrachten</h1>
      <input
        type="text"
        placeholder="Filter"
        v-model="filter"
        @input="setFilter"
        class="filter grey-field"
      />
      <close-button class="close-button" @click="$emit('close')"></close-button>
    </header>
    <main class="dialog-content">
      <order-list></order-list>
    </main>
  </section>
</template>
<script>
import { defineComponent } from 'vue'
import OrderList from './OrderList.vue'
import { EventBus } from '@/eventbus/EventBus'

export default defineComponent({
  name: 'OrderHistoryDialog',
  components: { OrderList },
  data() {
    return {
      filter: ''
    }
  },
  methods: {
    setFilter() {
      EventBus.emit('filter-orders', this.filter)
    }
  }
})
</script>
<style scoped lang="scss">
@use '../../sass/helpers/_variables.scss' as *;

.container {
  height: 100%;
}
main {
  height: calc(100% - 45px);
}

.dialog-header {
  display: flex;
  align-items: center;
  gap: 12px;

  h1 {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.container .dialog-content {
  padding-top: 10px;
}

.filter {
  flex: 0 1 120px;
  min-width: 0;
  margin-top: -10px;
  margin-right: 25px;
}

@media (max-width: $mobile-max-width) {
  .filter {
    flex: 0 1 100px;
    margin-right: 10px;
  }
}
</style>
